<template>

  <m-pay-layout>
    <template slot="links">
      <router-link v-if="order.transactionIds && order.transactionIds.length === 1"
        :to="{ name: 'transaction', params: { transactionId: order.transactionIds[0] } }">
        <v-btn small flat color="secondary">
          Transaction
          <v-icon small right dark class="ml-1">playlist_add_check</v-icon>
        </v-btn>
      </router-link>
      <router-link v-if="order.merchantId"
                   :to="{ name: 'merchant', params: { merchantId: order.merchantId } }">
        <v-btn small flat color="secondary">
          Merchant
          <v-icon small right dark class="ml-1">store</v-icon>
        </v-btn>
      </router-link>
      <router-link v-if="order.transactionIds && order.transactionIds.length > 1"
        :to="{ name: 'transactions', query: { f_orderId: order.id } }">
        <v-btn small flat color="secondary">
          Transactions
          <v-icon small right dark class="ml-1">playlist_add_check</v-icon>
        </v-btn>
      </router-link>
      <router-link v-if="order.consumerCreditId"
                   :to="{
                      name: 'consumer-credit',
                      params: { consumerCreditId: order.consumerCreditId } }"
      >
        <v-btn small flat color="secondary">
          Loan
          <v-icon small right dark class="ml-1">euro</v-icon>
        </v-btn>
      </router-link>
    </template>
    <v-layout justify-space-around :column="$vuetify.breakpoint.smAndDown">

      <m-pay-confirm-dialog
        :show="showConfirmationDialog"
        :title="confirmationDialog.description"
        @yes="confirmationDialog.action"
        @cancel="hideDialog"
        maxWidth="700px"
      />

      <v-flex>
        <v-card class="mb-3 mx-2">

          <m-pay-generic-viewer
            title="Order Details"
            :bean="order"
            :beanProperties="viewableOrderProperties"
            :formatters="{ createdDate: formatDate }"
          />
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="mb-3 mx-2">
          <v-card-title>
            <span class="headline">Order items</span>
          </v-card-title>
          <m-pay-merchant-order-items-table
            :orderId="$route.params.orderId"
          />
        </v-card>

        <v-card v-if="order.shipment != null" class="mb-3 mx-2">
          <m-pay-generic-viewer
            title="Shipping information"
            :bean="orderShipping"
            :beanProperties="shippingProperties"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayUserDetailsEditor from '../MPayUserDetailsEditor';
import MPayConfirmDialog from '../MPayConfirmDialog';
import formatters from '../../utils/formatters';
import roles from '../../utils/user-roles';
import MPayGenericViewer from '../MPayGenericViewer';
import MPayMerchantOrderItemsTable from './MPayMerchantOrderItemsTable';

export default {
  name: 'MPayOrderDetailsView',

  components: {
    MPayUserDetailsEditor,
    MPayConfirmDialog,
    MPayGenericViewer,
    MPayMerchantOrderItemsTable,
  },

  data: () => ({
    order: {},
    isAdmin: false,
    loading: false,
    showConfirmationDialog: false,
    confirmationDialog: {
      action: () => {
      },
      title: '',
      description: '',
    },
    formatters,
    viewableOrderProperties: [
      'id',
      'externalId',
      'customerEmail',
      'amount',
      'tax',
      'currency',
      'status',
      'createdDate',
      'merchantName',
      'rejectReasonCode',
      'error',
    ],
    fieldRoles: {
      error: roles.READ_ANY_PURCHASE,
    },
    orderShipping: {},
    shippingProperties: [
      'type',
      'contactPhone',
      'country',
      'city',
      'addressLine',
      'postalCode',
      'method',
    ],

  }),

  methods: {
    fetchOrder() {
      this.loading = true;
      axios.get(queries.merchantOrder(this.$route.params.orderId))
        .then((response) => {
          this.order = response.data;
          this.orderShipping = response.data.shipment;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    formatDate(timestamp) {
      if (timestamp) {
        return `${timestamp.substring(0, 10)} ${timestamp.substring(11, 16)}`;
      }
      return timestamp;
    },
  },
  watch: {
    $route() {
    },
  },

  mounted() {
    this.fetchOrder();
  },

};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayOrderDetailsView.vue